import _ from 'underscore';
import $ from 'jquery';
import Cache from 'root/cache';
import Svg_Icon from 'root/module/svg_icon';
import Lang from 'root/module/widget_translation';
import Util from 'root/module/util';
import View from 'view/base';
import {getLauncherIcon} from 'view/widget_studio/launcher_preview';

export default View.extend({
    className: 'widget-form-preview',

    form_type: '',  // bug, general, feature_request

    events: {
        'change select'                                : 'onDropdownChange',
        'click .userback-controls-feedback-type > div' : 'onSelectFeedbackType',
        'click .userback-controls-rating > div'        : 'onSelectRating',
        'click .userback-controls-nav > div'           : 'onSelectNav',
        'mouseenter .userback-controls-rating > div'   : 'onPreviewRating',
        'mouseleave .userback-controls-rating > div'   : 'onUnPreviewRating'
    },

    dom_handlers: {
        onSelectNav: function(e) {
            var component = $(e.currentTarget).data('val');

            this.trigger('Nav:Select', component);
        },

        onDropdownChange: function(e) {
            $(e.currentTarget).toggleClass('empty', $(e.currentTarget).val() === '');
        },

        onSelectFeedbackType: function(e) {
            $(e.currentTarget).addClass('selected').siblings().removeClass('selected');
        },

        onSelectRating: function(e) {
            var rating_type = this.model_setting[this.form_type].get('rating_type');

            this.$el.find('.userback-controls-rating > div').addClass('inactive');

            if (rating_type === 'emoji' || rating_type === 'number' || rating_type === 'thumb') {
                $(e.currentTarget).removeClass('inactive');
            } else if (rating_type === 'star' || rating_type === 'heart') {
                $(e.currentTarget).prevAll().removeClass('inactive');
                $(e.currentTarget).removeClass('inactive');
            }
        },

        onPreviewRating: function(e) {
            var rating_type = this.model_setting[this.form_type].get('rating_type');

            if (rating_type === 'star' || rating_type === 'heart') {
                this.$el.find('.userback-controls-rating > div').removeClass('highlight').addClass('preview');
                $(e.currentTarget).prevAll().addClass('highlight');
                $(e.currentTarget).addClass('highlight');
            } else if (rating_type === 'emoji' || rating_type === 'thumb') {
                this.$el.find('.userback-controls-rating > div').removeClass('highlight').addClass('preview');
                $(e.currentTarget).addClass('highlight');
            }
        },

        onUnPreviewRating: function(e) {
            this.$el.find('.userback-controls-rating > div').removeClass('highlight preview');
        }
    },

    initialize: function(options) {
        this.model         = options.model;         // widget
        this.model_setting = options.model_setting; // widget_setting

        if (this.model.isNextGen()) {
            this.form_type = 'general';
        }
    },

    setLanguage: function(language) {
        Lang.setLang(language);
    },

    setFormType: function(form_type, render_success) {
        this.form_type = form_type;
        this.render(render_success);
    },

    render: function(render_success) {
        var form_type = this.form_type; // bug, general, feature_request
        var step = form_type ? 'form' : 'layout';

        var routing_items = {};

        routing_items.screenshot = this.model.get('workflow_type').indexOf('capture') !== -1 ?
        '<div class="userback-feedback-type-form" data-val="capture">' +
            '<div>' + Svg_Icon.feedback_screenshot + '</div>' +
            '<div>' + (Util.htmlEntities( this.model.get('text_screenshot')) || Lang.get('draw_on_the_screen')) + '</div>' +
            '<div>' + (Util.htmlEntities( this.model.get('text_screenshot_help')) || Lang.get('draw_on_the_screen_help')) + '</div>' +
        '</div>': '';

        routing_items.video = this.model.get('workflow_type').indexOf('video') !== -1 ?
        '<div class="userback-feedback-type-form" data-val="video">' +
            '<div>' + Svg_Icon.feedback_video + '</div>' +
            '<div>' + (Util.htmlEntities(this.model.get('text_video')) || Lang.get('capture_video')) + '</div>' +
            '<div>' + (Util.htmlEntities(this.model.get('text_video_help')) || Lang.get('capture_video_help')) + '</div>' +
        '</div>' : '';

        routing_items.bug = this.model.get('workflow_type').indexOf('bug') !== -1 ?
        '<div class="userback-feedback-type-form" data-val="bug">' +
            '<div>' + Svg_Icon.feedback_bug + '</div>' +
            '<div>' + (Util.htmlEntities(this.model.get('text_report_bug')) || Lang.get('report_bug', true)) + '</div>' +
            '<div>' + (Util.htmlEntities(this.model.get('text_report_bug_help')) || Lang.get('report_bug_help', true)) + '</div>' +
        '</div>' : '';

        routing_items.feature_request = this.model.get('workflow_type').indexOf('feature_request') !== -1 ?
        '<div class="userback-feedback-type-form" data-val="feature_request">' +
            '<div>' + Svg_Icon.feedback_feature_request + '</div>' +
            '<div>' + (Util.htmlEntities(this.model.get('text_feature_request')) || Lang.get('feature_request', true)) + '</div>' +
            '<div>' + (Util.htmlEntities(this.model.get('text_feature_request_help')) || Lang.get('feature_request_help', true)) + '</div>' +
        '</div>' : '';

        routing_items.general = this.model.get('workflow_type').indexOf('general') !== -1 ?
        '<div class="userback-feedback-type-form" data-val="general">' +
            '<div>' + Svg_Icon.feedback_general + '</div>' +
            '<div>' + (Util.htmlEntities(this.model.get('text_general')) || Lang.get('general_feedback')) + '</div>' +
            '<div>' + (Util.htmlEntities(this.model.get('text_general_help')) || Lang.get('general_feedback_help')) + '</div>' +
        '</div>' : '';

        routing_items.view_other = this.model.get('display_feedback') ?
        '<div class="userback-feedback-type-form" data-val="view_other">' +
            '<div>' + Svg_Icon.feedback_other + '</div>' +
            '<div>' + (Util.htmlEntities(this.model.get('text_view_other')) || Lang.get('view_other_feedback')) + '</div>' +
            '<div>' + (Util.htmlEntities(this.model.get('text_view_other_help')) || Lang.get('view_other_feedback_help')) + '</div>' +
        '</div>' : '';

        routing_items.help = this.model.get('help_link') ?
        '<div class="userback-feedback-type-form" data-val="help">' +
            '<div>' + Svg_Icon.feedback_help + '</div>' +
            '<div>' + (Util.htmlEntities(this.model.get('help_title')) || Lang.get('contact_us')) + '</div>' +
            '<div>' + (Util.htmlEntities(this.model.get('help_message')) || Lang.get('contact_us_help')) + '</div>' +
        '</div>' : '';

        // routing_item_order
        var item_order = this.model.get('routing_item_order').split(',');
        var routing_item_options = '';
        var routing_item_count = 0;

        _.each(routing_items, (item, item_type) => {
            if (item_order.indexOf(item_type) === -1) {
                routing_item_options += item;

                if (item) {
                    routing_item_count++;
                }
            }
        });

        item_order.forEach((item_type) => {
            if (typeof routing_items[item_type]) {
                routing_item_options += (routing_items[item_type] || '');

                if (routing_items[item_type]) {
                    routing_item_count++;
                }
            }
        });

        // when there is only one routing item, go to form directly
        if (routing_item_count === 1 || this.model.isNextGen()) {
            step = 'form';

            if (routing_items.bug) {
                form_type = 'bug';
            } else if (routing_items.general) {
                form_type = 'general';
            } else {
                form_type = 'feature_request';
            }
        }

        this.$el.find('.region-preview-form')
            .attr('data-modal', this.model.get('use_modal') ? 'true' : 'false')
            .attr('data-position', this.model.get('position'))
            .attr('data-style', this.model.get('style'));

        Lang.setLang(this.model.get('language'));

        var html = '';

        if (step === 'layout') {
            html =
            '<div class="userback-controls" data-step="1">' +
                '<div class="preview-close"><i class="far fa-times"></i></div>' +
                (this.model.get('logo') ?
                '<img class="userback-controls-logo" src="' + this.model.get('logo') + '">' : '') +
                (this.model.get('header_text') ?
                '<div class="userback-header-text">' + Util.htmlEntities(this.model.get('header_text')) + '</div>' : '') +
                '<div class="userback-controls-step" data-step="ap">' +
                    routing_item_options +
                '</div>' +

                (this.model.get('display_powered_by') ?
                '<div class="userback-footer">' +
                    '<span>Powered by</span>' + Svg_Icon.logo +
                '</div>' : '') +
            '</div>';
        } else if (step === 'form') {
            var form_settings = this.model_setting[form_type].attributes;

            var category_options = '';
            Cache.feedback_category.where({project_id: this.model.get('project_id')}).forEach((category_model) => {
                category_options += '<option>' + category_model.escape('name') + '</option>';
            });

            var assignee_options = '';
            Cache.app.getUsersByProject(this.model.get('project_id')).forEach((user_model) => {
                assignee_options += '<option>' + user_model.escape('name') + '</option>';
            });

            var custom_field_option =
            (form_settings.custom_field_1_type === 'short_answer' ?
            '<input type="text" placeholder="' + Util.htmlEntities(form_settings.custom_field_1_label) + '">' : '') +

            (form_settings.custom_field_1_type === 'long_answer' ?
            '<textarea placeholder="' + Util.htmlEntities(form_settings.custom_field_1_label) + '"></textarea>' : '') +

            (form_settings.custom_field_1_type === 'checkbox' ?
            '<div class="checkbox-container">' +
                '<div>' +
                    '<div class="checkbox" style="color:' + this.model.get('main_button_background_colour') + ';"><i class="fas fa-check" style="display:none;"></i></div>' +
                    '<div class="checkbox-label">' + Util.htmlEntitiesWithA(form_settings.custom_field_1_label, true) + '</div>' +
                '</div>' +
            '</div>' : '') +

            (form_settings.custom_field_1_type === 'disclaimer' && form_settings.custom_field_1_label ?
            '<div class="disclamier">' + Util.htmlEntitiesWithA(form_settings.custom_field_1_label, true) + '</div>' : '');

            var show_screenshot = form_settings.allow_screenshot;
            var show_video      = form_settings.allow_video;
            var show_attachment = form_settings.allow_attachment;

            var data_item = 0;

            if (show_screenshot) {
                data_item++;
            }

            if (show_video) {
                data_item++;
            }

            if (show_attachment) {
                data_item++;
            }

            var feedback_type = '';

            if (this.model.isNextGen()) {
                feedback_type +=
                '<div class="userback-controls-feedback-type"' + (this.model.get('feedback_type').split(',').length > 1 && !this.model.get('ai_feedback_type') ? '' : ' style="display:none;"') + '>' +
                '<select>' +
                    (this.model.get('feedback_type_default') === '' ?
                    '<option value="">' + Lang.get('select_empty', true) + '</option>' : '') +
                    [
                        { val: 'bug', lang: 'feedback_type_bug', setting: 'text_feedback_type_bug' },
                        { val: 'feature_request', lang: 'feedback_type_feature_request', setting: 'text_feedback_type_feature_request' },
                        { val: 'general', lang: 'feedback_type_general', setting: 'text_feedback_type_general' }
                    ].map((data) => {
                        if (this.model.get('feedback_type').indexOf(data.val) === -1) {
                            return '';
                        } else {
                            return '<option' + (this.model.get('feedback_type_default') === data.val ? ' selected' : '') + '>' + (this.model.get(data.setting) || Lang.get(data.lang, true)) + '</option>';
                        }
                    }).join('') +
                '</select>' +
                '</div>';
            }


            var form_header = '';
            var outro_icon  = '';

            var name_tooltip = this.model.isNextGen()  ? 'Name is pre-filled and hidden for identified users' : 'Name is pre-filled for identified users';
            var email_tooltip = this.model.isNextGen() ? 'Email is pre-filled and hidden for identified users' : 'Email is pre-filled for identified users';

            var field_items = {
                name           : form_settings.name_field          ? '<div class="user-id-field"><span class="tooltip" data-title="' + name_tooltip + '"><i class="fa-solid fa-circle-info text-warning"></i></span><input type="text" name="name" placeholder="' + (Util.htmlEntities(form_settings.name_field_placeholder) || Lang.get('your_name')) + '"></div>' : '',
                email          : form_settings.email_field         ? '<div class="user-id-field"><span class="tooltip" data-title="' + email_tooltip + '"><i class="fa-solid fa-circle-info text-warning"></i></span><input type="email" name="email" placeholder="' + (Util.htmlEntities(form_settings.email_field_placeholder) || Lang.get('your_email_address')) + '" required=""></div>' : '',
                title          : form_settings.title_field         ? '<input type="text" name="title" placeholder="' + (Util.htmlEntities(form_settings.title_field_placeholder) || Lang.get('feedback_title', true)) + '">' : '',
                comment        : form_settings.comment_field       ? (this.model.isNextGen() ?
                                                                     '<div class="field-comment">' +
                                                                         '<textarea name="description" data-gramm_editor="false" placeholder="' + (Util.htmlEntities(form_settings.comment_field_placeholder) || Lang.get('leave_us_your_comment')) + '"></textarea>' +
                                                                         feedback_type +
                                                                     '</div>' :
                                                                     '<textarea name="description" data-gramm_editor="false" placeholder="' + (Util.htmlEntities(form_settings.comment_field_placeholder) || Lang.get('leave_us_your_comment')) + '"></textarea>') : '',
                category       : form_settings.display_category    ? '<select name="category" class="empty"><option value="">' + (Util.htmlEntities(form_settings.category_field_placeholder) || Lang.get('select_a_category')) + '</option>' + category_options + '</select>' : '',
                priority       : form_settings.display_priority    ? '<select name="priority" class="empty"><option value="">' + (Util.htmlEntities(form_settings.priority_field_placeholder) || Lang.get('select_a_priority', true)) + '</option><option>Urgent</option><option>High</option><option>Neutral</option><option>Low</option></select>' : '',
                assignee       : form_settings.display_assignee    ? '<select name="assignee" class="empty"><option value="">' + (Util.htmlEntities(form_settings.assignee_field_placeholder) || Lang.get('assign_to')) + '</option>' + assignee_options + '</select>' : '',
                custom_field_1 : form_settings.custom_field_1_type ? custom_field_option : '',
            };

            if (this.model.isNextGen()) {

            }

            var field_order = form_settings.field_order.split(',');
            var field_options = '';

            field_order.forEach((field_name) => {
                if (typeof field_items[field_name] !== 'undefined') {
                    field_options += field_items[field_name];
                }
            });

            switch (form_settings.outro_icon) {
                case 1:
                    outro_icon = Svg_Icon.outro_checkmark;
                    break;
                case 2:
                    outro_icon = Svg_Icon.outro_message_check;
                    break;
                case 3:
                    outro_icon = Svg_Icon.outro_hand_clapping;
                    break;
                case 4:
                    outro_icon = Svg_Icon.outro_thumb_up;
                    break;
                case 5:
                    outro_icon = Svg_Icon.widget_stars;
                    break;
                case 6:
                    outro_icon = '<div class="emoji-icon"><span>🥳</span></div>';
                    break;
                case 7:
                    outro_icon = '<div class="emoji-icon"><span>👏</span></div>';
                    break;
                case 8:
                    outro_icon = '<div class="emoji-icon"><span>👍</span></div>';
                    break;
                case 9:
                    outro_icon = '<div class="emoji-icon"><span>✨</span></div>';
                    break;
                case 10:
                    outro_icon = '<div class="emoji-icon"><span>🎉</span></div>';
                    break;
            }

            switch (form_type) {
                case 'bug':
                    form_header = (Util.htmlEntities(this.model.get('text_report_bug')) || Lang.get('report_bug', true));
                    break;
                case 'general':
                    form_header = (Util.htmlEntities(this.model.get('text_general')) || Lang.get('general_feedback', true));
                    break;
                case 'feature_request':
                    form_header = (Util.htmlEntities(this.model.get('text_feature_request')) || Lang.get('feature_request', true));
                    break;
            }

            if (this.model.isNextGen()) {
                form_header = this.model.escape('header_text').replace(/%%(.*?)%%/g, '<span class="wildcard-preview">$1</span>') || Lang.get('welcome_message', true);
            }


            html =
            '<div class="userback-controls"' + (this.model.isNextGen() ? ' nextgen="1"' : '') + (this.model.hasBottomNav() ? ' hasnav="1"' : '') + '>' +
                '<div class="userback-controls-header">' +
                    (this.model.isNextGen() ? '' :
                    '<div class="userback-controls-back' + (routing_item_count === 1 ? ' disabled' : '') + '"><i class="fa-regular fa-angle-left"></i></div>') +
                    '<div class="userback-controls-header-text">' +
                        (this.model.isNextGen() ? (
                            (this.model.get('logo') ? '<img src="' + this.model.escape('logo') + '">' : '') ||
                            getLauncherIcon(this.model.get('icon')) ||
                            Svg_Icon.widget_pointer) : '') +
                        '<div>' + form_header + '</div>' +
                    '</div>' +
                    '<div class="userback-controls-close">' +
                        '<i class="fa-regular fa-xmark"></i>' +
                    '</div>' +
                '</div>' +
                '<div class="userback-controls-step" data-step="fs">' +
                    '<div class="userback-controls-options">' +
                        (form_settings.rating_help_message ?
                        '<div class="userback-controls-help-message">' + Util.htmlEntities(form_settings.rating_help_message) + '</div>' : '') +

                        (form_settings.rating_type === 'star' ?
                        '<div class="userback-controls-rating">' +
                            '<div class="inactive" data-type="star">' + Svg_Icon.star_sharp + '</div>' +
                            '<div class="inactive" data-type="star">' + Svg_Icon.star_sharp + '</div>' +
                            '<div class="inactive" data-type="star">' + Svg_Icon.star_sharp + '</div>' +
                            '<div class="inactive" data-type="star">' + Svg_Icon.star_sharp + '</div>' +
                            '<div class="inactive" data-type="star">' + Svg_Icon.star_sharp + '</div>' +
                        '</div>' : '') +

                        (form_settings.rating_type === 'heart' ?
                        '<div class="userback-controls-rating">' +
                            '<div class="inactive" data-type="heart">' + Svg_Icon.heart + '</div>' +
                            '<div class="inactive" data-type="heart">' + Svg_Icon.heart + '</div>' +
                            '<div class="inactive" data-type="heart">' + Svg_Icon.heart + '</div>' +
                            '<div class="inactive" data-type="heart">' + Svg_Icon.heart + '</div>' +
                            '<div class="inactive" data-type="heart">' + Svg_Icon.heart + '</div>' +
                        '</div>' : '') +

                        (form_settings.rating_type === 'emoji' ?
                        '<div class="userback-controls-rating">' +
                            '<div class="inactive" data-type="emoji">' + Svg_Icon.face_hate + '</div>' +
                            '<div class="inactive" data-type="emoji">' + Svg_Icon.face_dislike + '</div>' +
                            '<div class="inactive" data-type="emoji">' + Svg_Icon.face_neutral + '</div>' +
                            '<div class="inactive" data-type="emoji">' + Svg_Icon.face_like + '</div>' +
                            '<div class="inactive" data-type="emoji">' + Svg_Icon.face_love + '</div>' +
                        '</div>' : '') +

                        (form_settings.rating_type === 'number' ?
                        '<div class="userback-controls-rating">' +
                            '<div class="inactive" data-type="number">1</div>' +
                            '<div class="inactive" data-type="number">2</div>' +
                            '<div class="inactive" data-type="number">3</div>' +
                            '<div class="inactive" data-type="number">4</div>' +
                            '<div class="inactive" data-type="number">5</div>' +
                        '</div>' : '') +

                        (form_settings.rating_type === 'thumb' ?
                        '<div class="userback-controls-rating">' +
                            '<div class="inactive" data-type="thumb">' + Svg_Icon.thumb_up + '</div>' +
                            '<div class="inactive" data-type="thumb">' + Svg_Icon.thumb_down + '</div>' +
                        '</div>' : '') +

                        field_options +

                        (show_video || show_screenshot || show_attachment ?
                        '<div class="userback-controls-attach-actions" data-item="' + data_item + '">' +
                            '<div>' +
                                (show_screenshot ?
                                '<btn class="userback-controls-screenshot">' +
                                    (this.model.isNextGen() ?
                                    '<i class="fa-solid fa-camera"></i>' :
                                    '<i class="fa-solid fa-draw-square"></i>') +
                                    '<div>' + Lang.get('attach_a_screenshot') + '</div>' +
                                    '<utooltip>' + Lang.get('attach_a_screenshot') + '</utooltip>' +
                                '</btn>' : '') +

                                (show_video ?
                                '<btn class="userback-controls-video">' +
                                    '<i class="fa-solid fa-video"></i>' +
                                    '<div>' + Lang.get('capture_video') + '</div>' +
                                    '<utooltip>' + Lang.get('capture_video') + '</utooltip>' +
                                '</btn>' : '') +

                                (show_attachment ?
                                '<btn class="userback-controls-add-attachment">' +
                                    '<i class="fa-regular fa-paperclip"></i>' +
                                    '<div>' + Lang.get('attach_a_file') + '</div>' +
                                    '<utooltip>' + Lang.get('attach_a_file') + '</utooltip>' +
                                '</btn>' : '') +
                            '</div>' +
                        '</div>' : '') +

                        '<div class="text-align-right margin-top-24">' +
                            '<button type="button" class="userback-controls-send primary small' + (this.model.isNextGen() ? ' fluid' : '') + '" style="color:' + this.model.get('main_button_text_colour') + ';background-color:' + this.model.get('main_button_background_colour') + ';">' + (Util.htmlEntities(form_settings.send_button_text) || Lang.get('send')) + '</button>' +
                        '</div>' +
                    '</div>' +

                    (this.model.get('display_powered_by') && !this.model.hasBottomNav() ?
                    '<div class="userback-footer">' +
                        '<span>Powered by</span>' + Svg_Icon.logo +
                    '</div>' : '') +
                '</div>' +

                (this.model.hasBottomNav() ?
                '<div class="userback-controls-nav">' +
                    '<div class="active" data-val="feedback">' +
                        '<i class="fa-solid fa-message-lines"></i>' +
                        (Util.htmlEntities(this.model.get('text_feedback')) || Lang.get('feedback', true)) +
                    '</div>' +
                    (this.model.get('workflow_type').indexOf('portal') !== -1 ?
                    '<div data-val="portal">' +
                        '<i class="fa-light fa-lightbulb-on"></i>' +
                        (Util.htmlEntities(this.model.get('text_portal')) || Lang.get('ideas_portal', true)) +
                    '</div>' : '') +
                    (this.model.get('workflow_type').indexOf('roadmap') !== -1 ?
                    '<div data-val="roadmap">' +
                        '<i class="fa-light fa-chart-mixed"></i>' +
                        (Util.htmlEntities(this.model.get('text_roadmap')) || Lang.get('roadmap', true)) +
                    '</div>' : '') +
                    (this.model.get('workflow_type').indexOf('announcement') !== -1 ?
                    '<div data-val="announcement">' +
                        '<i class="fa-light fa-bullhorn"></i>' +
                        (Util.htmlEntities(this.model.get('text_announcement')) || Lang.get('announcement', true)) +
                    '</div>' : '') +
                    (this.model.get('help_link') ?
                    '<div data-val="help">' +
                        '<i class="fa-light fa-circle-question"></i>' +
                        (Util.htmlEntities(this.model.get('help_title')) || Lang.get('contact_us')) +
                    '</div>' : '') +
                '</div>' : '') +

                (this.model.get('display_powered_by') && this.model.hasBottomNav() ?
                '<div class="userback-footer userback-footer-sticky">' +
                    '<span>Powered by</span>' + Svg_Icon.logo +
                '</div>' : '') +

                (render_success ?
                '<style>' +
                '.userback-controls-outro-message .ub-checkmark-outro {' +
                    'box-shadow: inset 0px 0px 0px ' + this.model.get('main_button_background_colour') + ';' +
                '}' +
                '.userback-controls-outro-message .ub-checkmark-outro__circle {' +
                    'stroke: ' + this.model.get('main_button_background_colour') + ';' +
                '}' +
                '@keyframes ub-checkmark-outro-fill {' +
                    '100% {' +
                        'box-shadow: inset 0px 0px 0px 30px ' + this.model.get('main_button_background_colour') + ';' +
                    '}' +
                '}' +
                '</style>' +
                '<div class="userback-controls-outro">' +
                    '<div class="preview-close"><i class="far fa-times"></i></div>' +
                    '<div class="userback-controls-outro-message" data-icon="' + form_settings.outro_icon + '">' +
                        outro_icon +

                        '<div class="outro-headline">' + Util.htmlEntities(form_settings.outro_headline).replace(/%%(.*?)%%/g, '<span class="wildcard-preview-text">%%$1%%</span>') + '</div>' +
                        '<p class="outro-paragraph">' + Util.htmlEntitiesWithA(form_settings.outro_paragraph, true).replace(/%%(.*?)%%/g, '<span class="wildcard-preview-text">%%$1%%</span>') + '</p>' +
                    '</div>' +
                    (this.model.get('display_powered_by') ?
                    '<div class="userback-footer">' +
                        '<span>Powered by</span>' + Svg_Icon.logo +
                    '</div>' : '') +
                '</div>' : '') +
            '</div>';
        }

        html +=
        '<style>' +
        '.widget-form-preview {' +
            '--widget-preview-button-bg: ' + this.model.get('main_button_background_colour') + ' !important;' +
            '--widget-preview-button-text: ' + this.model.get('main_button_text_colour') + ' !important;' +
            '--widget-preview-launcher-offset-x: ' + this.model.get('launcher_offset_x') + 'px;' +
            '--widget-preview-launcher-offset-y: ' + this.model.get('launcher_offset_y') + 'px;' +
        '}' +
        '</style>';

        this.$el.html(html);
        this.$el.find('svg .colour').css('fill', this.model.get('main_button_background_colour'));

        return this;
    }
});